import React, { Component } from 'react';
import { apiCalling, awsAPIUrlcommon } from "../apiService";
import { ToastContainer, toast } from 'react-toastify';
export default class WhatsappPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: '',
            endDate: ''
        };
    }

    getCurrentMonth = () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
    }

    handleDateChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    // handleSubmit = async (e) => {
    //     e.preventDefault();
    //     const { startDate, endDate } = this.state;

    // }

    handleClose = () => {
        this.setState({
            startDate: '',
            endDate: ''
        }, () => {
            this.props.onClose();
        });
    }

    resetDates = () => {
        this.setState({
            startDate: '',
            endDate: ''
        });
    }
    send = () => {
        if (this.props.sendPdfUrl) {
            let WhatsappData = {
                method: "POST",
                body: JSON.stringify({
                    functionName: "sendWhatsAppMessage",
                    fromPageType: "phDashboard",
                    mobileNumber: window.sessionStorage.getItem("doctorNumber"),
                    doctorId: window.sessionStorage.getItem("doctorDashBId"),
                    siteId: window.sessionStorage.getItem("doctor-reportSiteId"),
                    filePath: this.props.sendPdfUrl
                }),
            }
            awsAPIUrlcommon(WhatsappData).then((data) => {
                if (data.success === "1") {
                    toast.success("Succefully send");
                    setTimeout(() => {
                        this.props.onClose()
                    }, 2000);
                }
            }).catch((error) => {
                toast.error("An error occurred while getting details");
            });
        }
    }
    render() {
        const { isOpen } = this.props;
        const { startDate, endDate } = this.state;
        const currentMonth = this.getCurrentMonth();

        if (!isOpen) return null;

        return (
            <div className="popup-overlay" style={{ display: "block" }}>
                <ToastContainer />
                <div className="modal-dialog" style={{ maxWidth: "400px", minHeight: "450px" }} role="document">
                    <div className="modal-content">
                        <div className="modal-header modal-popup">
                            <h5 className="modal-title">Send Pdf</h5>
                        </div>

                        <div className="content p-4">

                            <div className="row">
                                <div className="col-12 mb-2">
                                    <label className="label-text" htmlFor="endDate">
                                        Number
                                    </label>
                                    <input
                                        type="text"

                                        className="input-design"
                                        value={window.sessionStorage.getItem("doctorNumber")}

                                        required
                                    />
                                </div>
                            </div>

                            <div className="text-center mt-2">
                                <button
                                    type="submit"
                                    className="sitesetng-svebtn" onClick={this.send}
                                >
                                    Send
                                </button>
                                <button
                                    type="button"
                                    className="sitesetng-cancelbtn"
                                    onClick={this.handleClose}
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}